(() => {
  function sanitizeCount(value) {
    const count = Number(value);

    if (!Number.isFinite(count) || count < 0) {
      return 0;
    }

    return Math.floor(count);
  }

  function getWishlistCount() {
    if (
      window.CTWishlist &&
      typeof window.CTWishlist.getHandles === 'function'
    ) {
      const handles = window.CTWishlist.getHandles();

      return Array.isArray(handles)
        ? handles.length
        : 0;
    }

    return 0;
  }

  function updateHeaderWishlist(count = getWishlistCount()) {
    const safeCount = sanitizeCount(count);

    document
      .querySelectorAll('[data-ct-header-wishlist]')
      .forEach((wishlistLink) => {
        const countElement = wishlistLink.querySelector(
          '[data-ct-header-wishlist-count]'
        );

        const labelElement = wishlistLink.querySelector(
          '[data-ct-header-wishlist-label]'
        );

        if (countElement) {
          countElement.textContent =
            safeCount > 99 ? '99+' : String(safeCount);

          countElement.hidden = safeCount === 0;
        }

        if (labelElement) {
          labelElement.textContent =
            `Wishlist, ${safeCount} sản phẩm`;
        }

        wishlistLink.setAttribute(
          'aria-label',
          `Wishlist, ${safeCount} sản phẩm`
        );
      });
  }

  document.addEventListener(
    'ct:wishlist:updated',
    (event) => {
      const count = event.detail?.count;

      updateHeaderWishlist(
        typeof count === 'number'
          ? count
          : getWishlistCount()
      );
    }
  );

  document.addEventListener(
    'DOMContentLoaded',
    () => {
      updateHeaderWishlist();
    }
  );

  window.addEventListener('pageshow', () => {
    updateHeaderWishlist();
  });

  window.CTWishlistHeader = {
    refresh() {
      updateHeaderWishlist();
    },
  };
})();